import { vuexHandbook } from '@/store/composition/handbook'
import { WORKSHOP_URL, WorkshopApi } from '@/api/handbook/position/Workshop/WorkshopApi'

const state = () => ({
  ...vuexHandbook.createState(),
  api: WorkshopApi,
  url: WORKSHOP_URL
})

const getters = {
  ...vuexHandbook.createGetters()
}

const mutations = {
  ...vuexHandbook.createMutations()
}

const actions = {
  ...vuexHandbook.createActions()

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
